import { getCampaignCookie } from '../utilities/getCampaignCookie';
import { getFacebookCampaignCookies } from '../utilities/getFacebookCampaignCookies';
import { isMarketingConsentApproved } from '../utilities/isMarketingConsentApproved';
import { getTgtgReferral } from '../utilities/getTgtgReferral';

export function useParseMarketing() {
  const route = useRoute();

  function getMarketingParams(locale: string) {
    const campaign = getCampaignCookie(document).join('&').replace(/&+$/, '');
    const consent = `cookie_consent=${!!isMarketingConsentApproved()}`;
    const country_locale = `locale=${locale}`;
    const facebookParams =  getFacebookCampaignCookies(document).length > 0 ? getFacebookCampaignCookies(document) : undefined;

    return `?${consent}&${country_locale}${campaign ? '&' + campaign : ''}${facebookParams ? '&' + facebookParams : ''}`;
  }

  function getReferrer(document: Document) {
    const referralId = getTgtgReferral(route)?.referred_by;
    return referralId ? [`referred_by=${referralId}`] : [];
  }

  return {
    getMarketingParams,
    getReferrer,
    getCampaignCookie,
    getFacebookCampaignCookies,
  };
}
